'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import Image from 'next/image';
import { Card, CardBody } from 'reactstrap';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { getI18nUtils } from '../i18n/i18n-utils';
import { Dictionaries, Locale } from '../i18n/i18n-config';

function CompanyTeaser({
  className,
  company,
  dictionary,
}: {
  className?: string;
  company: any;
  dictionary?: Partial<Dictionaries>;
}) {
  const { locale }: { locale: Locale } = useParams();
  const { formatMessage } = getI18nUtils(dictionary || {});
  if (!company) return null;

  const { logo, title, intro, uri } = company;
  return (
    <Card className={`${className || ''}`}>
      <div className="logoContainer d-block mx-auto">
        <Image className="logo" src={logo} width={180} height={180} alt={`${title} logo`} />
      </div>
      <CardBody>
        <div>{intro}</div>
        {uri && (
          <Link
            href={`/${locale}/${uri.replace(/^\//, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-primary btn-sm mt-2"
          >
            {formatMessage({ id: 'job-detail-company-link' })}
          </Link>
        )}
      </CardBody>
    </Card>
  );
}

export default CompanyTeaser;
